import React from 'react'
import Grid from '@material-ui/core/Grid'
import ResultImage from 'steps/shared/quiz-trivia/ResultImage'
import Bridge from 'steps/shared/Bridge'
import ResultRelatedBreak from 'steps/shared/quiz-trivia/ResultRelatedBreak'
import ShareIcons from 'components/ShareIcons'
import orientation from 'util/orientation'

const ResultSlide = ({
  isEditorial,
  isGuest,
  result,
  guestPointsEarned,
  relatedBreaks,
  socialShareOn,
}) => {
  let style = {}

  if (result && result.backgroundColor) {
    style.backgroundColor = result.backgroundColor
  }

  if (result && result.backgroundImage && result.backgroundImage.id) {
    style.backgroundImage = `url(${process.env.SITE_ASSET_URL}/${result.backgroundImage.id})`
  }

  return (
    <div className="quiz__item bg-img quiz-end" style={style}>
      <div className="container">
        {result && (
          <Grid container justify="center" spacing={2}>
            <Grid item xs={12} sm={11} md={9}>
              <div
                className={`quiz__inner-box quiz__answer${
                  result.backgroundImage ? ' bg-image' : ' no-bg-image'
                }${
                  isGuest ? ' user-is-guest' : ' user-is-logged-in'
                } ${orientation(result)}`}
              >
                <div className="quiz__answer-title">
                  {isEditorial === true && (
                    <span className={`answer-eyebrow`}>Results</span>
                  )}
                  <h2 dangerouslySetInnerHTML={{ __html: result.title }}></h2>
                </div>

                <div className="quiz__answer-copy">
                  <p dangerouslySetInnerHTML={{ __html: result.desc }}></p>
                  {isEditorial === true && socialShareOn === true && (
                    <ShareIcons />
                  )}
                </div>
                <div className="quiz__answer-image-container">
                  <figure className="quiz__answer-image">
                    <ResultImage result={result} />
                  </figure>
                </div>
              </div>
              {isEditorial === true && isGuest && (
                <Bridge pointsEarned={guestPointsEarned} />
              )}
            </Grid>
          </Grid>
        )}
        {isEditorial === true && isGuest === false && (
          <ResultRelatedBreak relatedBreaks={relatedBreaks} />
        )}
      </div>
    </div>
  )
}
export default ResultSlide
